import StripeMethodApiUtils from '../utils/api/stripeMethod';
import { hide as hideModal } from './modal';
import { addMessage as addFlashMessage } from './flash';

export const REQUEST_STRIPE_CARD_TOKEN_SENT = 'REQUEST_STRIPE_CARD_TOKEN_SENT';
export const REQUEST_STRIPE_CARD_TOKEN_SUCCEEDED =
  'REQUEST_STRIPE_CARD_TOKEN_SUCCEEDED';
export const REQUEST_STRIPE_CARD_TOKEN_FAILED =
  'REQUEST_STRIPE_CARD_TOKEN_FAILED';
export const FETCH_STRIPE_CARD_SENT = 'FETCH_STRIPE_CARD_SENT';
export const FETCH_STRIPE_CARD_SUCCEEDED = 'FETCH_STRIPE_CARD_SUCCEEDED';
export const FETCH_STRIPE_CARD_FAILED = 'FETCH_STRIPE_CARD_FAILED';
export const ADD_STRIPE_CARD_SENT = 'ADD_STRIPE_CARD_SENT';
export const ADD_STRIPE_CARD_SUCCEEDED = 'ADD_STRIPE_CARD_SUCCEEDED';
export const ADD_STRIPE_CARD_FAILED = 'ADD_STRIPE_CARD_FAILED';
export const CHANGE_DEFAULT_STRIPE_CARD_SENT =
  'CHANGE_DEFAULT_STRIPE_CARD_SENT';
export const CHANGE_DEFAULT_STRIPE_CARD_SUCCEEDED =
  'CHANGE_DEFAULT_STRIPE_CARD_SUCCEEDED';
export const CHANGE_DEFAULT_STRIPE_CARD_FAILED =
  'CHANGE_DEFAULT_STRIPE_CARD_FAILED';
export const REMOVE_STRIPE_CARD_SENT = 'REMOVE_STRIPE_CARD_SENT';
export const REMOVE_STRIPE_CARD_SUCCEEDED = 'REMOVE_STRIPE_CARD_SUCCEEDED';
export const REMOVE_STRIPE_CARD_FAILED = 'REMOVE_STRIPE_CARD_FAILED';

export function requestStripeCardTokenSent() {
  return { type: REQUEST_STRIPE_CARD_TOKEN_SENT };
}

export function requestStripeCardTokenSucceeded(data) {
  return {
    type: REQUEST_STRIPE_CARD_TOKEN_SUCCEEDED,
    payload: data,
  };
}

export function requestStripeCardTokenFailed(error) {
  return {
    type: REQUEST_STRIPE_CARD_TOKEN_FAILED,
    payload: error,
  };
}

// Note: Token creation is now handled directly in AddPaymentMethod component
// using Stripe Elements. The action creators above are still used by the component.

export function fetchCardSent() {
  return { type: FETCH_STRIPE_CARD_SENT };
}

export function fetchCardSucceeded(data) {
  return {
    type: FETCH_STRIPE_CARD_SUCCEEDED,
    payload: data,
  };
}

export function fetchCardFailed(error) {
  return {
    type: FETCH_STRIPE_CARD_FAILED,
  };
}

export function fetchCard() {
  return (dispatch) => {
    dispatch(fetchCardSent());
    return StripeMethodApiUtils.fetchCard().then(
      (data) => dispatch(fetchCardSucceeded(data)),
      (error) => dispatch(fetchCardFailed(error)),
    );
  };
}

export function addCardSent() {
  return { type: ADD_STRIPE_CARD_SENT };
}

export function addCardSucceeded(data) {
  return {
    type: ADD_STRIPE_CARD_SUCCEEDED,
    payload: data,
  };
}

export function addCardFailed(error) {
  return {
    type: ADD_STRIPE_CARD_FAILED,
    payload: error,
  };
}

export function addCard(cardToken, isStepModal = false) {
  return (dispatch) => {
    dispatch(addCardSent());
    return StripeMethodApiUtils.addCard(cardToken).then(
      (data) => {
        dispatch(addCardSucceeded(data));
        if (!isStepModal) {
          dispatch(hideModal());
          dispatch(
            addFlashMessage(data.message, {
              type: 'success',
              autoDisappear: true,
              sticky: true,
            }),
          );
        }
      },
      (error) => {
        dispatch(addCardFailed(error));
      },
    );
  };
}

export function changeDefaultCardSent() {
  return { type: CHANGE_DEFAULT_STRIPE_CARD_SENT };
}

export function changeDefaultCardSucceeded(data) {
  return {
    type: CHANGE_DEFAULT_STRIPE_CARD_SUCCEEDED,
    payload: data,
  };
}

export function changeDefaultCardFailed(error) {
  return {
    type: CHANGE_DEFAULT_STRIPE_CARD_FAILED,
  };
}

export function changeDefaultCard() {
  return (dispatch) => {
    dispatch(changeDefaultCardSent());
    return StripeMethodApiUtils.changeDefaultCard().then(
      (data) => dispatch(changeDefaultCardSucceeded(data)),
      (error) => dispatch(changeDefaultCardFailed(error)),
    );
  };
}

export function removeCardSent() {
  return { type: REMOVE_STRIPE_CARD_SENT };
}

export function removeCardSucceeded(data) {
  return {
    type: REMOVE_STRIPE_CARD_SUCCEEDED,
    payload: data,
  };
}

export function removeCardFailed(error) {
  return {
    type: REMOVE_STRIPE_CARD_FAILED,
  };
}

export function removeCard() {
  return (dispatch) => {
    dispatch(removeCardSent());
    return StripeMethodApiUtils.removeCard().then(
      (data) => dispatch(removeCardSucceeded(data)),
      (error) => dispatch(removeCardFailed(error)),
    );
  };
}
